import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { getArticleList as _getArticleList, deleteArticle as _deleteArticle, updateArticleStatus } from '@/services/article';
export default {
  name: 'articlelist',
  components: {},
  i18n: require('./i18n-article'),
  data: function data() {
    return {
      title: "",
      articleStatus: undefined,
      page: 1,
      size: 20,
      total: 0,
      articleHost: '',
      isTableLoading: false,
      articleList: [],
      AllStatus: [{
        key: 0,
        value: this.$t('public.enable')
      }, {
        key: 1,
        value: this.$t('public.disable')
      }],
      confirmLoading: false,
      columns: [{
        //文章名称
        title: this.$t('articlelist.articleName'),
        dataIndex: 'title',
        key: 'title',
        width: '20%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'articleName' //自定义表格里面的内容
        }
      },
      //链接
      {
        title: this.$t('articlelist.articleLink'),
        width: '30%',
        ellipsis: true,
        scopedSlots: {
          customRender: 'articleLink' //自定义表格里面的内容
        }
      },
      //状态
      {
        title: this.$t('publicuse.status'),
        dataIndex: 'status',
        key: 'status',
        width: '7%',
        scopedSlots: {
          customRender: 'statustype' //自定义表格里面的内容
        }
      },
      //引用位置
      /* {
      	title: this.$t('articlelist.citationDistribution'),
      	dataIndex: 'citationDistribution',
      	key: 'citationDistribution',
      	width: '15%',
      	ellipsis: true,
      	scopedSlots: {
      		customRender: 'citationDistribution', //自定义表格里面的内容
      	},
      }, */
      //更新时间
      {
        title: this.$t('publicuse.updatetime'),
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        width: '15%'
      },
      //操作
      {
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        width: '13%'
      }]
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    //加载列表数据
    loadData: function loadData() {
      var self = this;
      self.page = 1;
      var param = {
        page: self.page,
        size: self.size,
        title: self.title,
        articleStatus: self.articleStatus
      };
      self.getArticleList(param);
    },
    getArticleList: function getArticleList(param) {
      var self = this;
      self.isTableLoading = true;
      _getArticleList(param).then(function (res) {
        if (res.data.code == 200) {
          self.articleHost = res.data.data.articleHost;
          localStorage.setItem('articleHost', res.data.data.articleHost);
          self.articleList = res.data.data.list;
          self.total = res.data.data.total;
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    //点击删除的时候，不关闭
    handleMenuClick: function handleMenuClick(record) {
      record.deleteVisible = true;
    },
    add: function add() {
      this.$router.push({
        path: 'addArticle'
      });
    },
    edit: function edit(id) {
      var routeData = this.$router.resolve({
        path: 'editArticle',
        query: {
          id: id
        }
      });
      window.open(routeData.href, '_blank');
    },
    // 更新状态
    updateStatus: function updateStatus(data) {
      var _this = this;
      var self = this;
      var param = {
        id: data.id,
        status: data.status == 0 ? 1 : 0
      };
      if (data.updateArticleStatusLoading) return;
      data.updateArticleStatusLoading = true;
      updateArticleStatus(param).then(function (res) {
        if (res.data.code == 200) {
          _this.loadData();
          _this.$message.success(_this.$t('public.updateSuccessfully'));
        }
      }).finally(function () {
        data.updateArticleStatusLoading = false;
      });
    },
    //删除文章
    deleteArticle: function deleteArticle(id) {
      var _this2 = this;
      _deleteArticle(id).then(function (res) {
        if (res.data.code == 200) {
          _this2.loadData();
          _this2.$message.success(_this2.$t('public.deleteSuccessfully'));
        }
      });
    },
    // 点击翻页按钮
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      var self = this;
      self.page = pagination.current;
      self.size = pagination.pageSize;
      var param = {
        page: pagination.current,
        size: pagination.pageSize,
        title: self.title,
        articleStatus: self.articleStatus
      };
      self.getArticleList(param);
    }
  }
};